import React, {Component} from "react";

import axios from 'axios';
import history from '../../../history';
import Constants from '../../../components/Constants/';
import {
    Row,
    Col,
    Button,
    Label,
    Input,
    Link,
    Table,
    Badge
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import AlertContainer from 'react-alert';

class ClientList extends Component {

  constructor(props) {
    super(props);

    this.refreshClientsList = this.refreshClientsList.bind(this);

    this.state = {
        clientsList: null,
        activePage: 1
      };

      /*
      * Configurações do alerta
      */
      this.alertOptions = {
        offset: 14,
        position: 'top right',
        theme: 'light',
        time: 10000,
        transition: 'scale'
      }

      this.refreshClientsList();
    }

    refreshClientsList(){
      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/client'
      })
      .then(response => {
          this.setState({
              clientsList: response.data
          });
      });
    }

    statusFormatter(cell, row){
      return (
        cell == "ACTIVE" ? <Badge color="success">Ativo</Badge> : <Badge color="danger">Inativo</Badge>
      );
    }

    actionsFormatter(cell, row){
      return (
        <Button color="info" onClick={() => { history.replace("/client/"+cell); }}><i className="fa fa-pencil fa-inverse"></i></Button>
      );
    }

    renderPaginationShowsTotal(start, to, total) {
      return (
        <p>
          Exibindo de { start } a { to }, total: { total }
        </p>
      );
    }

    render() {
      if(this.state.clientsList == null) return null;

      const tableOptions = {
        paginationSize: 10,
        hideSizePerPage: true,
        paginationShowsTotal: true,
        paginationShowsTotal: this.renderPaginationShowsTotal
      };

      const statusTypes = [ {
        value: 'ACTIVE',
        text: 'Ativo'
      }, {
        value: 'INACTIVE',
        text: 'Inativo'
      }];

      return(
          <div>
            <h2>Clientes</h2>
            <hr />

            <Button color="success" onClick={() => { history.replace("/client"); }}>
              <i className="fa fa-plus fa-inverse"></i>
              {'\u00A0'}
              Adicionar Cliente
            </Button>
            <br />

            <BootstrapTable ref="table" data={this.state.clientsList} version='4'
              striped hover pagination search searchPlaceholder='Pesquisa Geral'
              options={tableOptions} >
              <TableHeaderColumn dataField="name" dataSort={true} width='50%'>Nome</TableHeaderColumn>
              <TableHeaderColumn dataField="phone" dataSort={true} width='20%'>Telefone</TableHeaderColumn>
              <TableHeaderColumn dataField="status" dataFormat={this.statusFormatter} dataSort={true} width='10%'>Status</TableHeaderColumn>
              <TableHeaderColumn dataField="id" isKey={true} dataFormat={this.actionsFormatter} width='20%'><i className="fa fa-cog"></i></TableHeaderColumn>

            </BootstrapTable>
            <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
            <br />
          </div>
        )
    }
}

export default ClientList;



// WEBPACK FOOTER //
// ./src/views/admin/ClientList/ClientList.js